import type { Timestamp } from '@bufbuild/protobuf/wkt';
import { formatDate } from '@vueuse/core';
import { convertToDate } from 'gpcore-apikit/lib/date';

export default () => {
  /**
   * Formats a date into a string.
   *
   * Uses @vueuse/core formatDate function under the hood. See doc [useDateFormat](https://vueuse.org/shared/useDateFormat/) for more details.
   *
   * @param date - can be a Date object, a string, a number, a bigint or a protobuf Timestamp object
   * @param format - the format to use, defaults to 'yyyy-MM-dd HH:mm:ss'
   *
   * @returns a formatted date string
   */
  const format = (date: Date | number | bigint | Timestamp, format: 'short' | 'long' = 'long') => {
    let f = format as string;
    if (format === 'short') {
      f = 'YYYY-MM-DD HH:mm';
    } else if (format === 'long') {
      f = 'YYYY-MM-DD HH:mm:ss';
    }

    const d = convertToDate(date as number | bigint | Timestamp | Date);
    return formatDate(d, f);
  };

  return format;
};
